// Mock data for Netix Fibernet Referral Program

export const mockUser = {
  id: '1',
  firstName: 'Rajesh',
  lastName: 'Kumar',
  email: 'rajesh.kumar@example.com',
  referralCode: 'RAJESH2024',
  referralLink: 'https://netixfibernet.com/ref/RAJESH2024',
  isAuthenticated: false,
  payoutMethod: 'Bank Transfer',
  balance: 4500,
  pendingBalance: 2300,
  lifetimeEarnings: 15800,
  totalClicks: 234,
  totalConversions: 18,
  currentTier: 2,
  salesThisMonth: 8
};

export const mockTransactions = [
  {
    id: 'txn001',
    date: '2025-01-15',
    type: 'Sale',
    orderId: 'ORD-2025-001',
    customerName: 'Amit',
    amount: 1200,
    commission: 96,
    commissionRate: 8,
    status: 'Confirmed',
    product: 'Internet Lease Line - 100 Mbps'
  },
  {
    id: 'txn002',
    date: '2025-01-12',
    type: 'Sale',
    orderId: 'ORD-2025-002',
    customerName: 'Priya',
    amount: 2500,
    commission: 200,
    commissionRate: 8,
    status: 'Pending',
    product: 'CCTV Camera Package'
  },
  {
    id: 'txn003',
    date: '2025-01-10',
    type: 'Payout',
    orderId: '-',
    customerName: '-',
    amount: 3000,
    commission: -3000,
    commissionRate: 0,
    status: 'Paid',
    product: 'Withdrawal to Bank'
  },
  {
    id: 'txn004',
    date: '2025-01-08',
    type: 'Sale',
    orderId: 'ORD-2025-003',
    customerName: 'Sandeep',
    amount: 1800,
    commission: 144,
    commissionRate: 8,
    status: 'Confirmed',
    product: 'Internet Networking Setup'
  },
  {
    id: 'txn005',
    date: '2025-01-05',
    type: 'Sale',
    orderId: 'ORD-2025-004',
    customerName: 'Neha',
    amount: 3500,
    commission: 280,
    commissionRate: 8,
    status: 'Pending',
    product: 'Internet Lease Line - 200 Mbps'
  },
  {
    id: 'txn006',
    date: '2024-12-28',
    type: 'Adjustment',
    orderId: 'ORD-2024-098',
    customerName: 'Vikram',
    amount: 1500,
    commission: -120,
    commissionRate: 8,
    status: 'Rejected',
    product: 'CCTV Camera - Refunded'
  }
];

export const mockProducts = [
  {
    id: 'prod001',
    name: 'Internet Lease Line - Corporate',
    description: 'Dedicated high-speed internet connection',
    price: 'Contact us',
    commissionRate: 8,
    image: 'https://images.unsplash.com/photo-1594915440248-1e419eba6611?w=400&q=80'
  },
  {
    id: 'prod002',
    name: 'Internet Lease Line - Goverment',
    description: 'Premium dedicated internet for businesses',
    price: 'Contact us',
    commissionRate: 8,
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&q=80'
  },
  {
    id: 'prod003',
    name: 'CCTV Camera Package',
    description: 'Complete surveillance solution with installation',
    price: 'Contact us',
    commissionRate: 8,
    image: 'https://images.unsplash.com/photo-1528312635006-8ea0bc49ec63?w=400&q=80'
  },
  {
    id: 'prod004',
    name: 'Internet Networking Solution',
    description: 'Custom networking infrastructure design',
    price: 'Contact us',
    commissionRate: 8,
    image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=400&q=80'
  }
];

export const commissionTiers = [
  {
    tier: 1,
    name: 'Starter',
    salesRange: '0-5 Sales/Month',
    rate: 5,
    color: '#6b7280'
  },
  {
    tier: 2,
    name: 'Pro',
    salesRange: '6-15 Sales/Month',
    rate: 8,
    color: '#3b82f6'
  },
  {
    tier: 3,
    name: 'Elite',
    salesRange: '16+ Sales/Month',
    rate: 12,
    color: '#14b8a6'
  }
];

export const faqData = [
  {
    question: 'How do I get my referral link?',
    answer: 'After signup you\'ll receive a unique link on your dashboard. Copy & share anywhere.'
  },
  {
    question: 'How much can I earn?',
    answer: 'Commission varies from 5%-12% based on your performance tier. You earn higher rates when you hit volume tiers: 5% for 0-5 sales, 8% for 6-15 sales, and 12% for 16+ sales per month.'
  },
  {
    question: 'When do I get paid?',
    answer: 'Commissions move from Pending → Confirmed after the returns window (usually 30 days). Payouts are issued monthly or on-demand when you meet the minimum payout of ₹1,000.'
  },
  {
    question: 'What if a referred customer returns the product?',
    answer: 'If the order is refunded, the related commission will be reversed from your pending or available balance.'
  },
  {
    question: 'Can I use multiple links?',
    answer: 'Yes — you can create custom links or promo codes for campaigns and track them separately.'
  },
  {
    question: 'Is there a fee to join?',
    answer: 'No, registration is completely free.'
  }
];
